import Vue from "vue";
// import Vant from 'vant';
//
// Vue.use(Vant);

import {
  Tab,
  Tabs,
  NavBar,
  CellGroup,
  Field,
  Button,
  Dialog,
  Icon
} from "vant";

// import 'vant/lib/vant-css/index.css';

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Icon);
